class ProjectError extends Error {
  constructor (message?: string) {
    super(message ?? 'No project found')
  } 
}

export {
  ProjectError
}